import EventIcon from '@mui/icons-material/Event';
import InfoIcon from '@mui/icons-material/Info';
import NoteIcon from '@mui/icons-material/Note';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

import Badge from '@mui/material/Badge';
import { ContactDisplayAsideLayout } from '../../../sic-lib/enums/ContactDisplayLayout';
import { Contact } from '../../../sic-lib/types/Contact';
import { useAppSelector } from '../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    flexChild: {
        margin: `0px ${theme.spacing(1)}`,
    },
}));

const tabButtons: Array<{
    label: string;
    value: ContactDisplayAsideLayout;
    icon: React.ReactElement;
}> = [
    {
        label: 'Notes',
        value: ContactDisplayAsideLayout.notes,
        icon: <NoteIcon />,
    },
    {
        label: 'Info',
        value: ContactDisplayAsideLayout.info,
        icon: <InfoIcon />,
    },
    {
        label: 'Events',
        value: ContactDisplayAsideLayout.events,
        icon: <EventIcon />,
    },
    {
        label: 'Engage',
        value: ContactDisplayAsideLayout.engage,
        icon: <OpenInBrowserIcon />,
    },
];

interface Props {
    cdAsideDispatch: React.Dispatch<{ view: ContactDisplayAsideLayout }>;
    view: ContactDisplayAsideLayout;
    contact: Contact;
}

export default function AsideTabButtons({ cdAsideDispatch, view, contact }: Props) {
    const { classes } = useStyles();

    const hasEngagePlatform = useAppSelector(state => state.user.clientHasEngagePlatform);
    const engageToken = useAppSelector(state => state.user.engageToken || '');

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        cdAsideDispatch({
            view: event.currentTarget.value as ContactDisplayAsideLayout,
        });
    };

    const URL = `${engageToken}${contact.contactId}`;

    /*const URL = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ?
        `https://new.swsecure.test/Main/?key=${state.engageToken}#/Lead/${contactId}` :
        `https://6scentral.com/Main/?key=${state.engageToken}#/Lead/${contactId}`*/

    // const handleEngageClick = () => {
    //     window.open(URL, '_blank');
    // }

    return (
        <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center">
            {tabButtons.map(btn => (
                <Grid key={btn.value} item xs="auto">
                    {btn.label !== 'Engage' && btn.label !== 'Events' && (
                        <Tooltip title={btn.label} className={classes.flexChild}>
                            <Badge
                                badgeContent=" "
                                color="primary"
                                variant="dot"
                                invisible={view !== btn.value}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        left: 24,
                                        bottom: 6,
                                    },
                                }}
                            >
                                <IconButton value={btn.value} onClick={handleClick} size="large">
                                    {btn.icon}
                                </IconButton>
                            </Badge>
                        </Tooltip>
                    )}
                    {btn.label === 'Engage' && hasEngagePlatform && (
                        <a href={URL} target="child" className={classes.flexChild}>
                            <Tooltip title={btn.label}>
                                <IconButton value={btn.value} onClick={() => null} size="large">
                                    {btn.icon}
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </Grid>
            ))}
        </Grid>
    );
}
